import InputComponent from "components/formInput/Input";
import { Checkbox, Col, Row } from "antd";
import { Container } from "react-bootstrap";
import ButtonComponent from "components/button/Button";
import { useEffect, useState } from "react";
import TableComponent from "components/table/Table";
import { FormOutlined } from "@ant-design/icons";
import { ROUTE } from "routes/route";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import SelectComponent from "components/select/Select";
import Loading from "components/loading/Loading";

import "./styles.scss";
import {
  apiDelPatients,
  apiExportCSVPatient,
  apiExportCSVAllPatient,
  apiGetPatients,
} from "helpers/api/master/patients";
import { apiGetMasterArea } from "helpers/api/master/master";
import { apiGetClinics } from "helpers/api/clinic";
import ModalConfirm from "components/popup-confirm";
import { showToastError, showToastSuccess } from "utils";
import { useLocation } from 'react-router-dom';

const AdminPatientsPage = (props) => {
  const history = useHistory();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  let p = searchParams.get("p");

  if (!p) {
    p = 1
  }

  const [isLoading, setIsLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [patients, setPatients] = useState([]);
  const [cities, setCities] = useState([]);
  const [clinics, setClinics] = useState([]);
  const [filters, setFilters] = useState({});
  const [keySearch, setKeySearch] = useState("");
  const [inputSeach, setInputSeach] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isClinic, setIsClinic] = useState(false);
  const [page, setPage] = useState(p);
  const [totalPage, setTotalPage] = useState(1);
  const [isReload, setIsReload] = useState(false);

  const addQueryParam = (key, value) => {
    const params = new URLSearchParams(window.location.search);
    params.set(key, value);
    window.history.pushState({}, "", `${window.location.pathname}?${params}`);
  };

  const updatePage = (newPage) => {
    addQueryParam("p", newPage)
    setPage(newPage)
  }

  useEffect(() => {
    setIsLoading(true);
    apiGetPatients({
      filter: Object.values(filters).join(","),
      key_search: keySearch,
      page,
      limit: 15,
    })
      .then((resp) => {
        setIsLoading(false);
        setIsReload(false);
        let newPatients = [];
        if (resp.data) {
          newPatients = resp.data.map((item, index) => ({
            ...item,
            key: item.id,
          }));
          setPage(resp.page);
          setTotalPage(resp.total_page);
        }
        setPatients(newPatients);
        setSelectedRowKeys([]);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [filters, keySearch, page, totalPage, isReload]);

  useEffect(() => {
    if (!p) {
      p = 1
    }
    setPage(p);
  }, [p]);

  useEffect(() => {
    apiGetMasterArea()
      .then((resp) => {
        if (resp.data) {
          const cityArr = resp.data.map((city) => ({
            label: city.name,
            value: city.id,
          }));
          cityArr.unshift({ label: "全て", value: "" });
          setCities(cityArr);
        }
      })
      .catch((err) => {
        console.log(err);
      });

    apiGetClinics().then((resp) => {
      if (resp.data) {
        const clinicArr = resp.data.map((clinic) => ({
          label: clinic.clinic_name,
          value: clinic.id,
        }));
        clinicArr.unshift({ label: "全て", value: "" });
        setClinics(clinicArr);
      }
    });
  }, []);

  const columns = [
    {
      title: "患者名",
      align: "center",
      key: "name",
      render: (item) => {
        return (
          <a
            style={{
              textDecoration: "underline"
            }}
            onClick={() => { history.push(ROUTE.ADMIN.GRAPH.replace(":id", item.id)) }}
          >
            {`${item.first_name} ${item.last_name}`}
          </a>
        )
      },
    },
    {
      title: "都道府県",
      align: "center",
      dataIndex: "area_id",
      key: "area",
      render: (text) => {
        return <span>{cities.find((city) => city.value === text)?.label}</span>;
      },
    },
    {
      title: "性別",
      dataIndex: "gender",
      align: "center",
      key: "gender",
      render: (gender) => {
        return <span>{gender === "FEMALE" ? "女" : "男"}</span>;
      },
    },
    {
      title: "生年月日／年齢",
      dataIndex: "date_of_birth",
      align: "center",
      key: "date_of_birth",
      render: (date) => {
        const today = new Date();
        const birthDay = new Date(date);
        let age = parseInt(today.getFullYear() - birthDay.getFullYear());
        if (today.getMonth() < birthDay.getMonth() || (today.getMonth() == birthDay.getMonth() && today.getDate() < birthDay.getDate())) {
          age = age - 1;
        }

        return (
          <span>{`${date} (${age < 0 ? 0 : age})`}</span>
        );
      },
    },
    {
      title: "登録かかりつけクリニック",
      align: "center",
      dataIndex: "clinic_name",
      key: "clinic_name",
    },
    {
      title: "",
      width: 50,
      align: "center",
      key: "action",
      render: (item) => {
        return (
          <FormOutlined
            fill="#0687BB"
            onClick={() =>
              history.push(ROUTE.ADMIN.PATIENTS_EDIT.replace(":id", item.id))
            }
          />
        );
      },
    },
  ];

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleChangeSelect = (val, name) => {
    setPage(1);
    setFilters((prevFilters) => {
      if (name === "clinicId") {
        setIsClinic(false);
      }

      if (val === "") {
        delete prevFilters[name];

        return {
          ...prevFilters,
        };
      }

      return {
        ...prevFilters,
        [name]: `${name}:${val}`,
      };
    });
  };

  const handleSearch = () => {
    setKeySearch(inputSeach);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      setPage(1);
      handleSearch();
    }
  };

  const handlerClickDeletePatients = () => {
    apiDelPatients({ patient_ids: selectedRowKeys })
      .then((resp) => {
        if (resp.data) {
          showToastSuccess("messages.MSG-USP054");
          setIsModalOpen(false);
          setIsReload(true);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handlerClickExportCSV = () => {
    setIsLoading(true);
    apiExportCSVPatient({
      patient_ids: selectedRowKeys
    })
      .then((resp) => {
        setIsLoading(false);
        if (resp.data) {
          window.location.href = resp.data;
          showToastSuccess("messages.MSG-USP024");
          setSelectedRowKeys([]);
        }
      })
      .catch((err) => {
        console.log(err);
        showToastError("messages.MSG-USP097");
      });
  };

  const handlerClickExportAllPatientCSV = () => {
    setIsLoading(true);
    apiExportCSVAllPatient()
      .then((resp) => {
        setIsLoading(false);
        if (resp.data) {
          window.location.href = resp.data;
          showToastSuccess("messages.MSG-USP024");
          setSelectedRowKeys([]);
        }
      })
      .catch((err) => {
        console.log(err);
        showToastError("messages.MSG-USP097");
      });
  };

  const handleChangeCheckbox = (e) => {
    setIsClinic(e.target.checked);
    setPage(1);
    if (e.target.checked) {
      setFilters((prevFilters) => ({
        ...prevFilters,
        clinicId: "clinicId:NOT_CLINIC",
      }));
    } else {
      setFilters((prevFilters) => {
        delete prevFilters.clinicId;
        return {
          ...prevFilters,
        };
      });
    }
  };

  return (
    <div className="main-content">
      <div className="root-right-header">
        <div className="screen-name">三和Admin</div>
      </div>
      <div className="nav screen-title">患者情報</div>

      <div className="" style={{ marginLeft: "30px" }}>
        <Container>
          {/* --- Row: Search + Buttons --- */}
          <Row gutter={[16, 16]} className="mb-3">
            <Col xs={24} md={7}>
              <div style={{ maxWidth: "400px", width: "100%" }}>
                <InputComponent
                  suffix={
                    <img
                      alt="search"
                      src="/icons/search_img.png"
                      className="ic x2"
                      onClick={handleSearch}
                    />
                  }
                  placeholder="患者検索"
                  onKeyDown={handleKeyDown}
                  onChange={(val) => setInputSeach(val.target.value)}
                />
              </div>
            </Col>

            <Col xs={24} md={17}>
              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  flexWrap: "wrap",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  marginRight: "20px",
                }}
              >
                <ButtonComponent
                  background="#11b5f6"
                  style={{ minWidth: 120 }}
                  text="リストデータ出力"
                  disabled={selectedRowKeys.length === 0 ? "true" : ""}
                  onClick={handlerClickExportCSV}
                />
                <ButtonComponent
                  background="#11b5f6"
                  style={{ minWidth: 120 }}
                  text="全件データ出力"
                  onClick={handlerClickExportAllPatientCSV}
                />
                <ButtonComponent
                  background="#fb5757"
                  style={{ minWidth: 120, marginLeft: 16 }}
                  text="削除"
                  disabled={selectedRowKeys.length === 0 ? "true" : ""}
                  onClick={() => setIsModalOpen(true)}
                />
              </div>
            </Col>


          </Row>

          {/* --- Row: Filters --- */}
          <Row gutter={[16, 16]} className="mb-3">
            <Col xs={24} sm={12} md={6}>
              <div className="label-select-wrap">
                <span style={{ minWidth: 70 }}>都道府県</span>
                <SelectComponent
                  style={{ width: "100%", height: "32px" }}
                  name="area"
                  options={cities}
                  value={filters.area ? filters.area.replace("area:", "") : ""}
                  onChange={(val) => handleChangeSelect(val, "area")}
                />
              </div>
            </Col>

            <Col xs={24} sm={12} md={6}>
              <div className="label-select-wrap">
                <span style={{ minWidth: 40 }}>性別</span>
                <SelectComponent
                  style={{ width: "100%", height: "32px" }}
                  name="gender"
                  options={[
                    { label: "全て", value: "" },
                    { label: "女", value: "FEMALE" },
                    { label: "男", value: "MALE" },
                  ]}
                  value={filters.gender ? filters.gender.replace("gender:", "") : ""}
                  onChange={(val) => handleChangeSelect(val, "gender")}
                />
              </div>
            </Col>

            <Col xs={24} sm={12} md={6}>
              <div className="label-select-wrap">
                <span style={{ minWidth: 90 }}>クリニック名</span>
                <SelectComponent
                  style={{ width: "100%", height: "32px" }}
                  name="clinic"
                  options={clinics}
                  value={
                    filters.clinicId && filters.clinicId !== "clinicId:NOT_CLINIC"
                      ? filters.clinicId.replace("clinicId:", "")
                      : ""
                  }
                  onChange={(val) => handleChangeSelect(val, "clinicId")}
                />
              </div>
            </Col>

            <Col xs={24} sm={12} md={6} className="d-flex align-items-end">
              <Checkbox
                name="no_clinic"
                checked={isClinic}
                onChange={handleChangeCheckbox}
              >
                かかりつけ医無し
              </Checkbox>
            </Col>
          </Row>

          {/* Table + Modal + Loading */}
          <TableComponent
            columns={columns}
            dataSource={patients}
            rowSelection={rowSelection}
            page={page}
            totalPage={totalPage}
            showPagination={totalPage > 1}
            onChangePage={(newPage) => updatePage(newPage)}
          />

          <ModalConfirm
            content="本当に削除しますか。"
            open={isModalOpen}
            onOkText="削除"
            onCancelText="キャンセル"
            onOkColor="red"
            onOk={handlerClickDeletePatients}
            onCancel={() => setIsModalOpen(false)}
          />

          {isLoading && <Loading />}
        </Container>

      </div>
    </div>
  );
};

export default AdminPatientsPage;
